import * as React from "react";
import { cn } from "./cn";

export type EmptyStateProps = {
  icon?: React.ReactNode;
  title: string;
  description?: React.ReactNode;
  action?: React.ReactNode;
  className?: string;
};

export function EmptyState({
  icon,
  title,
  description,
  action,
  className,
}: EmptyStateProps) {
  return (
    <div
      className={cn(
        "rounded-[24px] bg-mist px-8 py-12 flex flex-col items-center text-center",
        className,
      )}
    >
      {icon ? (
        <div className="mb-4 h-16 w-16 rounded-full bg-smoke/80 flex items-center justify-center text-ash">
          {icon}
        </div>
      ) : null}
      <p className="text-ink font-bold text-base mb-1">{title}</p>
      {description ? (
        <p className="max-w-sm text-ash text-sm mb-6">{description}</p>
      ) : null}
      {action}
    </div>
  );
}
